import { Flex } from '@mantine/core'
import { useState, useEffect } from 'react'

import { useTranslation } from '@flecto/translations'
import { type CoreInquiry } from '@flecto/types'
import { InputSearch } from '@flecto/ui'

type FiltersInquiriesProps = {
  inquiries?: CoreInquiry[]
  onFilter?: (data: CoreInquiry[]) => void
}

type InquiryProperty =
  | 'full_name'
  | 'internal_id'
  | 'email'
  | 'phone_number'
  | 'status'

export function FiltersInquiries({
  inquiries,
  onFilter,
}: FiltersInquiriesProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'inquiries' })
  const [filter, setFilter] = useState('')

  const handleFilterChange = (value: string) => {
    setFilter(value)
  }

  useEffect(() => {
    const propertiesToCheck: InquiryProperty[] = [
      'full_name',
      'internal_id',
      'email',
      'phone_number',
      'status',
    ]

    const fitleredInquiries = (inquiries ?? []).filter((inquiry) =>
      propertiesToCheck.some((property) =>
        inquiry[property]
          ?.toString()
          .toLowerCase()
          .includes(filter.toLowerCase())
      )
    )

    onFilter?.(fitleredInquiries)
  }, [inquiries, filter])

  return (
    <Flex gap={'md'} align={'center'}>
      <InputSearch
        placeholder={t('label_search')}
        onChange={handleFilterChange}
      />
    </Flex>
  )
}
